import React, { useState, useEffect, useCallback } from "react";
import {
  AlertTriangle,
  WhoWeAreImgpowerd,
  fillDetails,
  logo,
} from "../../Common/CommonImages";
import { useNavigate } from "react-router-dom";
import {
  FormControl,
  Box,
  TextField,
  Button,
  FormHelperText,
  Typography,
  Stack,
  Divider,
  InputAdornment,
  Chip,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { useDispatch, useSelector } from "react-redux";
import "react-phone-number-input/style.css";
import { BASE_URL, handleDynamicRequest } from "../../Common/CommonExport";
import CommonModal from "../../Components/CommonModal";
import {
  setCandidateEmail,
  setCandidateName,
  setExtraFieldArray,
  setCandidateCollegeName,
  setCandidateMobile,
  setCandidateResume,
  setCandidateRetake,
} from "../../store/Candidate/action";
import { setRemainingTime } from "../../store/Test/action";
import { useMessage } from "../../Components/snackbar/snackbar";
import AssessmentHeader from "../../Components/AssessmentHeader";



// ── Main Component ─────────────────────────────────────────────────────────────
function EnterDetails() {
  const { showSuccess, showError } = useMessage();
  const [showModal, setShowModal] = useState(false);
  const [isApplicationLinkModalOpen, setIsApplicationLinkModalOpen] =
    useState(false);
  const [isPreferencesModalOpen, setPreferencesModalOpen] = useState(false);
  const [jobApplicationLink, setJobApplicationLink] = useState("");
  const [jobId, setJobId] = useState("");
  const [jobApplication, setJobApplication] = useState(null);
  const [openedApplicationWindow, setOpenedApplicationWindow] = useState(null);
  const [openedPreferencesWindow, setOpenedPreferencesWindow] = useState(null);
  const [shouldRecheckEligibility, setShouldRecheckEligibility] =
    useState(false);

  const toggleModal = () => setShowModal(!showModal);

  const getFormsAppURL = () => process.env.REACT_APP_FORMS_APP_URL;

  const candidateResume = useSelector((state) => state.candidateReducer.resume);
  const [selectedFile, setSelectedFile] = useState(candidateResume ?? null);
  const testId = useSelector((state) => state.testReducer.testId);
  const testLink = useSelector((state) => state.testReducer.testLink);
  const testTime = useSelector((state) => state.testReducer.time);
  const candidateSettings = useSelector((state) => state.testReducer.candidate);
  const testSettings = useSelector((state) => state.testReducer.setting);
  const candidateDetails = {
    name: useSelector((state) => state.candidateReducer.name),
    email: useSelector((state) => state.candidateReducer.email),
    mobile: useSelector((state) => state.candidateReducer.mobile),
    collegeName: useSelector((state) => state.candidateReducer.collegeName),
    extraFields: useSelector((state) => state.candidateReducer.fields),
    resume: useSelector((state) => state.candidateReducer.resume),
  };

  const [final, setFinal] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const hasSystemCheck = testSettings?.some(
    (s) => s.setting === "Restrict peripheral device usage" && s.active,
  );

  const handlePage = () => {
    if (hasSystemCheck) {
      navigate("/check-system");
    } else {
      navigate("/start-test");
    }
  };

  const handleEnterDetails = () => {
    const parts = testLink.split("/");
    const testDetails = parts.pop();
    const userId = parts.pop();
    navigate(`/summary/${userId}/${testDetails}`);
  };

  useEffect(() => {}, [final]);

  useEffect(() => {
    const convertToSeconds = (timeString) => {
      const [hours, minutes, seconds] = timeString.split(":").map(Number);
      return hours * 3600 + minutes * 60 + seconds;
    };
    const totalSeconds = convertToSeconds(testTime);
    dispatch(setRemainingTime(totalSeconds));
  });

  useEffect(() => {
    const handleFormCompleted = (event) => {
      const formsAppURL = getFormsAppURL();
      if (event.origin !== formsAppURL) return;
      if (event.data.type === "FORM_COMPLETED") {
        setPreferencesModalOpen(false);
        setIsApplicationLinkModalOpen(false);
        if (openedPreferencesWindow) {
          openedPreferencesWindow.close();
          setOpenedPreferencesWindow(null);
        }
        if (openedApplicationWindow) {
          openedApplicationWindow.close();
          setOpenedApplicationWindow(null);
        }
        showSuccess("Form completed successfully! Proceeding with assessment.");
        setShouldRecheckEligibility(true);
      }
    };
    window.addEventListener("message", handleFormCompleted);
    return () => window.removeEventListener("message", handleFormCompleted);
  }, [openedPreferencesWindow, openedApplicationWindow, showSuccess]);

  useEffect(() => {
    if (shouldRecheckEligibility) {
      setShouldRecheckEligibility(false);
      handleCandidate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldRecheckEligibility]);

  const [formData, setFormData] = useState({
    name: candidateDetails.name,
    email: candidateDetails.email,
    ...candidateDetails?.extraFields,
    collegeName: candidateDetails.collegeName,
    mobile: candidateDetails.mobile,
    resume: candidateDetails.resume,
  });

  const [formErrors, setFormErrors] = useState({
    name: false,
    email: false,
    collegeName: false,
    mobile: false,
    resume: null,
  });

  const handleFormChangeEmail = (event) => {
    const { name, value } = event.target;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setFormErrors({ ...formErrors, email: !emailRegex.test(value) });
    setFormData({ ...formData, [name]: value });
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setFormErrors({
      ...formErrors,
      [name]: !/^[a-zA-Z-' ]+$/.test(value.trim()),
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const candidateFormFields = candidateSettings
      .filter((field) => field.field.name !== "resume" && field.active)
      .map((field) => field.field.name);

    let formIsValid = true;
    const newFormErrors = { ...formErrors };
    Object.entries(formData).forEach(([key, value]) => {
      if (candidateFormFields.includes(key) && !value) {
        newFormErrors[key] = true;
        formIsValid = false;
      }
    });
    setFormErrors(newFormErrors);
    if (formIsValid) handleCandidate();
  };

  useEffect(() => {
    if (selectedFile) {
      setFormErrors((prev) => ({ ...prev, resume: false }));
    }
  }, [selectedFile]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const fileType = file.name.split(".").pop().toLowerCase();
    if (["pdf", "doc", "docx"].includes(fileType)) {
      setSelectedFile(file);
    } else {
      showError("Invalid file type. Please upload a pdf, doc, or docx file.");
    }
  };

  const handleClearFile = () => setSelectedFile(null);

  const handleCandidate = () => {
    const requestBody = { email: formData.email, name: formData.name };
    const url = `${BASE_URL}/public/assessment/${testId}/candidate-eligibility`;

    handleDynamicRequest(
      "POST",
      url,
      requestBody,
      (data) => {
        if (data?.error) {
          setFinal(data.error);
          showError(data.error);
          setShowModal(true);
        }
      },
      (data) => {
        if (!data) return;
        if (data.applicantExists === false) {
          setJobId(data.jobId || "");
          const formsAppURL = getFormsAppURL();
          setJobApplicationLink(`${formsAppURL}/job/${data.jobId}`);
          setIsApplicationLinkModalOpen(true);
          return;
        }
        if (data.jobApplication && data.jobApplication.isComplete === false) {
          if (isPreferencesModalOpen) {
            showError("Please fill in your preferences before proceeding");
            return;
          }
          setJobApplication(data.jobApplication);
          setPreferencesModalOpen(true);
          return;
        }
        // 💰 CREDIT GUARD: Assessment locked for new responses (insufficient client balance)
        if (data.assessmentUnavailable) {
          navigate("/assessment-paused");
          return;
        }
        if (data.success) {
          showSuccess("Eligibility verified successfully!");
          dispatch(setCandidateEmail(formData.email));
          dispatch(setCandidateMobile(formData.mobile));
          dispatch(setCandidateName(formData.name));
          dispatch(setCandidateCollegeName(formData.collegeName));
          dispatch(setCandidateResume(selectedFile));
          dispatch(setCandidateRetake(true));
          const extraFields = Object.entries(formData).reduce(
            (acc, [key, value]) => {
              if (
                !["email", "name", "mobile", "collegeName", "resume"].includes(
                  key,
                )
              ) {
                acc[key] = value;
              }
              return acc;
            },
            {},
          );
          dispatch(setExtraFieldArray(extraFields));
          handlePage();
        } else {
          const msg =
            data.message || "Unable to verify eligibility. Please try again.";
          setFinal(msg);
          showError(msg);
          setShowModal(true);
        }
      },
    );
  };

  // ── Shared TextField sx ───────────────────────────────────────────────────
  const fieldSx = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      fontSize: "14px",
      bgcolor: "#fafafa",
      transition: "all 0.2s",
      "&:hover fieldset": { borderColor: "#FF6812" },
      "&.Mui-focused fieldset": {
        borderColor: "#FF6812",
        borderWidth: "1.5px",
      },
    },
    "& .MuiInputLabel-root.Mui-focused": { color: "#FF6812" },
    "& .MuiInputAdornment-root svg": { color: "#bbb", fontSize: 18 },
  };

  // ── Required label helper ─────────────────────────────────────────────────
  const reqLabel = (label) => (
    <span>
      {label}
      <span style={{ color: "#f44336", marginLeft: 3 }}>*</span>
    </span>
  );

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          bgcolor: "#f5f7fa",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* ── Unified Header ── */}
        <AssessmentHeader activeStep="Enter Details" hasSystemCheck={hasSystemCheck} />

        {/* ── Main Content ── */}
        <Box
          sx={{
            flex: 1,
            py: { base: 2 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: { base: "95%", sm: "75%" },
              mx: "auto",
            }}
          >
            {/* ── Card ── */}
            <Box
              component="form"
              autoComplete="off"
              onSubmit={handleFormSubmit}
              sx={{
                bgcolor: "#fff",
                borderRadius: "12px",
                boxShadow: "0 2px 20px rgba(0,0,0,0.07)",
                overflow: "hidden",
              }}
            >
              {/* Card Header */}
              <Box
                sx={{
                  padding: { base: "12px 16px", sm: "14px 24px" },
                  background: "linear-gradient(135deg, #fff 60%, #fff8f4 100%)",
                }}
              >
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Box
                    sx={{
                      width: 44,
                      height: 44,
                      borderRadius: "12px",
                      background: "linear-gradient(135deg, #FF6812, #ff9a5c)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      boxShadow: "0 3px 10px rgba(255,104,18,0.3)",
                    }}
                  >
                    <AssignmentIndOutlinedIcon
                      sx={{ fontSize: 24, color: "#fff" }}
                    />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: { base: "16px", xss: "17px", sm: "19px" },
                        fontWeight: 700,
                        color: "#1a1a2e",
                        lineHeight: 1.3,
                        mb: 0.2,
                      }}
                    >
                      Candidate Details
                    </Typography>
                    <Typography sx={{ fontSize: "13px", color: "#888" }}>
                      Please fill in your information to proceed
                    </Typography>
                  </Box>
                </Stack>
              </Box>

              <Divider sx={{ borderColor: "#bdbdbd" }} />

              {/* Form Fields */}
              <Box sx={{ padding: "20px 24px" }}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { base: "1fr", xss: "1fr 1fr" },
                    gap: { base: "12px", xss: "16px", sm: "20px" },
                  }}
                >
                  {candidateSettings?.map((field, index) => {
                    if (!field.active) return null;

                    if (field.field.name === "name") {
                      return (
                        <TextField
                          key={index}
                          name="name"
                          label={reqLabel("Full Name")}
                          variant="outlined"
                          fullWidth
                          value={formData.name}
                          onChange={handleFormChange}
                          error={formErrors.name}
                          helperText={
                            formErrors.name ? "Please enter a valid name" : ""
                          }
                          onCopy={(e) => e.stopPropagation()}
                          onCut={(e) => e.stopPropagation()}
                          onPaste={(e) => e.stopPropagation()}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <PersonOutlineIcon />
                              </InputAdornment>
                            ),
                          }}
                          sx={fieldSx}
                        />
                      );
                    }

                    if (field.field.name === "email") {
                      return (
                        <TextField
                          key={index}
                          name="email"
                          label={reqLabel("Email Address")}
                          variant="outlined"
                          fullWidth
                          value={formData.email}
                          onChange={handleFormChangeEmail}
                          error={formErrors.email}
                          helperText={
                            formErrors.email ? "Please enter a valid email" : ""
                          }
                          onCopy={(e) => e.stopPropagation()}
                          onCut={(e) => e.stopPropagation()}
                          onPaste={(e) => e.stopPropagation()}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <EmailOutlinedIcon />
                              </InputAdornment>
                            ),
                          }}
                          sx={fieldSx}
                        />
                      );
                    }

                    if (field.field.name === "collegeName") {
                      return (
                        <TextField
                          key={index}
                          name="collegeName"
                          label={reqLabel("College / University")}
                          variant="outlined"
                          fullWidth
                          value={formData.collegeName}
                          onChange={handleFormChange}
                          error={formErrors.collegeName}
                          helperText={
                            formErrors.collegeName
                              ? "Please enter a valid college name"
                              : ""
                          }
                          onCopy={(e) => e.stopPropagation()}
                          onCut={(e) => e.stopPropagation()}
                          onPaste={(e) => e.stopPropagation()}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <SchoolOutlinedIcon />
                              </InputAdornment>
                            ),
                          }}
                          sx={fieldSx}
                        />
                      );
                    }

                    if (field.field.name === "mobile") {
                      return (
                        <FormControl key={index} fullWidth>
                          <Box
                            sx={{
                              border: `1.5px solid ${formErrors.mobile ? "#f44336" : "#c4c4c4"}`,
                              borderRadius: "10px",
                              px: 1.5,
                              py: "13px",
                              bgcolor: "#fafafa",
                              transition: "border-color 0.2s",
                              "&:focus-within": {
                                borderColor: formErrors.mobile
                                  ? "#f44336"
                                  : "#FF6812",
                              },
                              "& .PhoneInput": { gap: "8px" },
                              "& .PhoneInputInput": {
                                border: "none",
                                outline: "none",
                                fontSize: "14px",
                                bgcolor: "transparent",
                                color: "#333",
                                width: "100%",
                              },
                              "& .PhoneInputCountrySelect": {
                                fontSize: "13px",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "11px",
                                color: formErrors.mobile ? "#f44336" : "#888",
                                mb: 0.5,
                                fontWeight: 500,
                              }}
                            >
                              Mobile No{" "}
                              <span style={{ color: "#f44336" }}>*</span>
                            </Typography>
                            <PhoneInput
                              placeholder="Enter mobile number"
                              name={field.field.name}
                              value={formData["mobile"]}
                              onChange={(value) => {
                                setFormData({ ...formData, mobile: value });
                                if (value) {
                                  setFormErrors((prev) => ({
                                    ...prev,
                                    mobile: !isValidPhoneNumber(value),
                                  }));
                                }
                              }}
                            />
                          </Box>
                          {formErrors.mobile && (
                            <FormHelperText error sx={{ ml: 1.5 }}>
                              Please enter a valid mobile number
                            </FormHelperText>
                          )}
                        </FormControl>
                      );
                    }

                    if (field.field.name === "resume") {
                      return (
                        <Box key={index} sx={{ gridColumn: { sm: "1 / -1" } }}>
                          <Typography
                            sx={{
                              fontSize: "13px",
                              fontWeight: 600,
                              color: "#555",
                              mb: 1,
                            }}
                          >
                            Resume / CV{" "}
                            <span style={{ color: "#f44336" }}>*</span>
                          </Typography>
                          {!selectedFile ? (
                            <label htmlFor="file-upload-ed">
                              <Box
                                sx={{
                                  border: "2px dashed #e0e0e0",
                                  borderRadius: "10px",
                                  p: 3,
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: 1,
                                  cursor: "pointer",
                                  bgcolor: "#fafafa",
                                  transition: "all 0.2s",
                                  "&:hover": {
                                    borderColor: "#FF6812",
                                    bgcolor: "#fff8f4",
                                  },
                                }}
                              >
                                <Box
                                  sx={{
                                    width: 44,
                                    height: 44,
                                    borderRadius: "10px",
                                    bgcolor: "#fff3ec",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <CloudUploadIcon
                                    sx={{ color: "#FF6812", fontSize: 22 }}
                                  />
                                </Box>
                                <Typography
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    color: "#444",
                                  }}
                                >
                                  Click to upload your resume
                                </Typography>
                                <Typography
                                  sx={{ fontSize: "11px", color: "#aaa" }}
                                >
                                  PDF, DOC, DOCX supported
                                </Typography>
                              </Box>
                              <input
                                type="file"
                                id="file-upload-ed"
                                style={{ display: "none" }}
                                accept=".pdf,.doc,.docx"
                                onChange={handleFileChange}
                              />
                            </label>
                          ) : (
                            <Box
                              sx={{
                                border: "1.5px solid #4caf5040",
                                borderRadius: "10px",
                                p: "10px 16px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                bgcolor: "#f0faf8",
                                gap: 1,
                              }}
                            >
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={1.5}
                              >
                                <Box
                                  sx={{
                                    width: 36,
                                    height: 36,
                                    borderRadius: "8px",
                                    bgcolor: "#e8f5e9",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <InsertDriveFileOutlinedIcon
                                    sx={{ color: "#4caf50", fontSize: 18 }}
                                  />
                                </Box>
                                <Box>
                                  <Typography
                                    sx={{
                                      fontSize: "13px",
                                      fontWeight: 600,
                                      color: "#333",
                                      maxWidth: { base: 160, sm: 300 },
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {selectedFile.name}
                                  </Typography>
                                  <Chip
                                    label="Uploaded"
                                    size="small"
                                    sx={{
                                      height: 18,
                                      fontSize: "10px",
                                      bgcolor: "#e8f5e9",
                                      color: "#4caf50",
                                      fontWeight: 600,
                                    }}
                                  />
                                </Box>
                              </Stack>
                              <IconButton
                                onClick={handleClearFile}
                                size="small"
                                sx={{
                                  color: "#f44336",
                                  "&:hover": { bgcolor: "#fdecea" },
                                }}
                              >
                                <ClearIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          )}
                          {formErrors.resume && (
                            <FormHelperText error sx={{ ml: 0.5 }}>
                              Please upload a valid resume
                            </FormHelperText>
                          )}
                        </Box>
                      );
                    }

                    return null;
                  })}
                </Box>
              </Box>

              <Divider sx={{ borderColor: "#bdbdbd" }} />

              {/* Footer Actions */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { base: "column", xss: "row" },
                  justifyContent: "space-between",
                  alignItems: "center",
                  px: { base: "16px", xss: "24px" },
                  py: "16px",
                  gap: { base: 2, xss: 0 },
                }}
              >
                <Button
                  onClick={handleEnterDetails}
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    height: 40,
                    borderColor: "#ddd",
                    color: "#555",
                    fontSize: "13px",
                    fontWeight: 600,
                    textTransform: "none",
                    borderRadius: "10px",
                    border: "1.5px solid #e0e0e0",
                    px: 3,
                    width: { base: "100%", xss: "auto" },
                    "&:hover": {
                      borderColor: "#FF6812",
                      color: "#FF6812",
                      bgcolor: "#fff8f4",
                    },
                    transition: "all 0.2s",
                  }}
                >
                  Back
                </Button>

                <Button
                  type="submit"
                  endIcon={<ArrowForwardIcon />}
                  sx={{
                    background: "linear-gradient(135deg, #FF6812, #ff9a5c)",
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: { base: "14px", xss: "15px" },
                    height: 42,
                    borderRadius: "10px",
                    textTransform: "none",
                    boxShadow: "0 4px 16px rgba(255,104,18,0.35)",
                    width: { base: "100%", xss: "auto" },
                    px: { xss: 4 },
                    "&:hover": {
                      background: "linear-gradient(135deg, #e55a0f, #ff8533)",
                      boxShadow: "0 6px 20px rgba(255,104,18,0.45)",
                      transform: "translateY(-1px)",
                    },
                    transition: "all 0.2s ease",
                  }}
                >
                  Proceed to Next
                </Button>
              </Box>
            </Box>

            {/* Footer */}
            <Box
              sx={{ mt: 4, mb: 2, display: "flex", justifyContent: "center" }}
            >
              <img
                src={WhoWeAreImgpowerd}
                alt="Powered by HireCorrecto"
                style={{ height: 28, width: 200 }}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      {/* ── Modals ── */}
      <CommonModal
        open={showModal}
        handleClose={toggleModal}
        title="Error"
        type="error"
        icon={AlertTriangle}
        showFooter={false}
      >
        <Box>
          <Typography
            sx={{
              fontSize: { base: "14px", sm: "16px" },
              color: "#444",
              lineHeight: 1.6,
              textAlign: { base: "center", xss: "left" },
            }}
          >
            {final}
          </Typography>
        </Box>
      </CommonModal>

      <CommonModal
        open={isPreferencesModalOpen}
        handleClose={() => setPreferencesModalOpen(false)}
        title="Fill in your preferences"
        type="warning"
        showFooter={false}
        icon={AlertTriangle}
      >
        <Box>
          <Typography
            sx={{
              fontSize: { base: "14px", sm: "16px" },
              color: "#444",
              lineHeight: 1.6,
              textAlign: { base: "center", xss: "left" },
            }}
          >
            Please fill in your preferences so that we can proceed with the
            assessment test.
          </Typography>
          <Stack
            direction={{ base: "column", xss: "row" }}
            spacing={{ base: 1.5, xss: 2 }}
            mt={3}
            justifyContent={{ base: "center", xss: "flex-end" }}
          >
            <Button
              variant="contained"
              color="orangeButton"
              size="small"
              disableElevation
              sx={{
                fontWeight: 600,
                fontSize: { base: "14px", sm: "16px" },
                color: "#fff",
                height: { base: 42, xss: 38 },
                px: 3,
                width: { base: "100%", xss: "auto" },
                borderRadius: "10px",
                textTransform: "none",
                boxShadow: "0 4px 12px rgba(255,104,18,0.2)",
                "&:hover": {
                  boxShadow: "0 6px 16px rgba(255,104,18,0.3)",
                },
              }}
              onClick={useCallback(() => {
                const formsAppURL = getFormsAppURL();
                const baseUrl = `${formsAppURL}/candidate-preferences/${jobApplication?._id}`;
                const newWindow = window.open(baseUrl, "_blank");
                setOpenedPreferencesWindow(newWindow);
                setPreferencesModalOpen(false);
                const checkWindowLoaded = setInterval(() => {
                  if (newWindow && !newWindow.closed) {
                    try {
                      newWindow.postMessage(
                        {
                          type: "INIT_FORM_DATA",
                          data: {
                            candidateId: jobApplication?._id,
                            source: "assessment",
                            assessmentId: testId,
                            candidateDetails: formData,
                          },
                        },
                        formsAppURL,
                      );
                      clearInterval(checkWindowLoaded);
                    } catch (e) {}
                  } else if (newWindow && newWindow.closed) {
                    clearInterval(checkWindowLoaded);
                  }
                }, 100);
              }, [jobApplication?._id, testId, formData])}
            >
              Fill in your preferences
            </Button>
          </Stack>
        </Box>
      </CommonModal>

      <CommonModal
        icon={AlertTriangle}
        open={isApplicationLinkModalOpen}
        handleClose={() => setIsApplicationLinkModalOpen(false)}
        title="Application not found"
        type="warning"
        showFooter={false}
      >
        <Box>
          <Typography
            sx={{
              fontSize: { base: "14px", sm: "16px" },
              color: "#444",
              lineHeight: 1.6,
              textAlign: { base: "center", xss: "left" },
            }}
          >
            You have not applied for this job. Please apply for the job to
            proceed with the assessment test.
          </Typography>
          <Stack
            direction={{ base: "column", xss: "row" }}
            spacing={{ base: 1.5, xss: 2 }}
            mt={3}
            justifyContent={{ base: "center", xss: "flex-end" }}
          >
            <Button
              variant="contained"
              color="orangeButton"
              size="small"
              disableElevation
              sx={{
                fontWeight: 600,
                fontSize: { base: "14px", sm: "16px" },
                color: "#fff",
                height: { base: 42, xss: 38 },
                px: 3,
                width: { base: "100%", xss: "auto" },
                borderRadius: "10px",
                textTransform: "none",
                boxShadow: "0 4px 12px rgba(255,104,18,0.2)",
                "&:hover": {
                  boxShadow: "0 6px 16px rgba(255,104,18,0.3)",
                },
              }}
              onClick={useCallback(() => {
                const formsAppURL = getFormsAppURL();
                const newWindow = window.open(jobApplicationLink, "_blank");
                setOpenedApplicationWindow(newWindow);
                const handleMessage = (event) => {
                  if (event.origin !== formsAppURL) return;
                  if (event.data.type === "WINDOW_READY") {
                    newWindow.postMessage(
                      {
                        type: "INIT_FORM_DATA",
                        data: {
                          source: "assessment",
                          assessmentId: testId,
                          candidateDetails: formData,
                          jobId: jobId,
                        },
                      },
                      formsAppURL,
                    );
                    window.removeEventListener("message", handleMessage);
                    setIsApplicationLinkModalOpen(false);
                  }
                };
                window.addEventListener("message", handleMessage);
                const checkWindowClosed = setInterval(() => {
                  if (newWindow.closed) {
                    window.removeEventListener("message", handleMessage);
                    clearInterval(checkWindowClosed);
                  }
                }, 1000);
              }, [jobApplicationLink, testId, jobId, formData])}
            >
              Apply for the job
            </Button>
          </Stack>
        </Box>
      </CommonModal>
    </>
  );
}

export default EnterDetails;
